import { createSitesApi } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

// The shared sites API bound to the web transport (cookie `authedFetch`).
// Mobile binds the same factory to its Bearer-sid transport.
export const { fetchSiteLocations } = createSitesApi(authedFetch);
